<sci-modal
  [title]="'views.projects.title.select' | translate"
  size="sm"
  [loading]="switching()"
  (dismissed)="ref.close()"
>
  <sci-form-select
    [formControl]="selectedProjectId"
    [label]="'views.projects.title.singular' | translate"
    [options]="projectOptions()"
    [required]="true"
    [placeholder]="'views.projects.title.select' | translate"
  />

  <sci-modal-footer>
    <button sci-button type="button" variant="link" color="neutral" (click)="ref.close()">
      {{ 'general.buttons.cancel' | translate }}
    </button>
    <button
      sci-button
      type="button"
      class="project-selector-modal__confirm"
      [disabled]="!canConfirm()"
      (click)="confirm()"
    >
      {{ 'views.projects.title.buttonselect' | translate }}
    </button>
  </sci-modal-footer>
</sci-modal>
